import React, { lazy } from "react";
import { Route } from "react-router-dom";

// Lazy load public pages
const Landing = lazy(() => import("@/pages/Landing/Landing"));

const Contact = lazy(() => import("@/pages/PublicPages/Contact/Contact"));
const About = lazy(() => import("@/pages/PublicPages/About/About"));
const Plans = lazy(() => import("@/pages/PublicPages/Membership/Plans"));

const PrivacyPolicy = lazy(() =>
  import("@/pages/PublicPages/LegalPages/PrivacyPolicy")
);
const TermsConditions = lazy(() =>
  import("@/pages/PublicPages/LegalPages/TermsConditions")
);

export const PublicRoutes = (
  <>
    <Route path="/" element={<Landing />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/about" element={<About />} />
    <Route path="/plans" element={<Plans />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-conditions" element={<TermsConditions />} />
  </>
);
